import { jsx as _jsx } from "react/jsx-runtime";
export function Card({ className = '', ...props }) {
    return (_jsx("div", { className: `rounded-lg border border-gray-200 bg-white shadow-sm ${className}`, ...props }));
}
export function CardHeader({ className = '', ...props }) {
    return (_jsx("div", { className: `flex flex-col space-y-1.5 p-6 ${className}`, ...props }));
}
export function CardTitle({ className = '', ...props }) {
    return (_jsx("h3", { className: `text-2xl font-semibold leading-none tracking-tight ${className}`, ...props }));
}
export function CardDescription({ className = '', ...props }) {
    return (_jsx("p", { className: `text-sm text-gray-500 ${className}`, ...props }));
}
export function CardContent({ className = '', ...props }) {
    return (_jsx("div", { className: `p-6 pt-0 ${className}`, ...props }));
}
export function CardFooter({ className = '', ...props }) {
    return (_jsx("div", { className: `flex items-center p-6 pt-0 ${className}`, ...props }));
}
